export default __webpack_public_path__ + "static/media/2.8438469d.png";